module.exports = __webpack_public_path__ + "img/Quote.06f922ef.svg";